import React from "react";
import UploadD from "./Components/UploadD";
import upload from "./assets/images/upload.png";
import processing from "./assets/images/processing.png";
import download from "./assets/images/download.png";
import logo from "./assets/images/skyraaconverter.svg";
import { Link, useParams, useLocation } from "react-router-dom";
import "./common.css";
import Footer from "./Components/Footer";
import Mainpage from "./Components/Mainpage";
import { useEffect, useRef } from "react";
import { Helmet } from "react-helmet";

const conversions = [
  {
    id: 1,
    type: "PNG ➝ JPG",
    title: "png-to-jpg",
    convertion_type: "jpg",
    input_format: "png",
    p1: "Converting PNG to JPG is ideal when you want to reduce the image file size for web use, sharing, or storage. PNGs are lossless and support transparency, but this comes at the cost of larger files. JPGs, on the other hand, use lossy compression which greatly reduces size.",
    p2: "This conversion works best when transparency isn’t required. Since JPG doesn’t support transparency, any transparent regions will be filled—often with a white or black background, depending on the software used. This suits photographs or artwork where transparency isn't essential.",
    p3: "JPG is more widely accepted across websites and platforms, particularly social media, blogs, and CMS platforms. It renders efficiently and loads quickly, which benefits SEO and performance on mobile or slower connections.",
    p4: "Also, JPG files offer flexible compression settings, allowing users to find the best balance between quality and file size. This makes them a preferred format for sharing and publishing large batches of images efficiently.",

    // SEO Properties
    seo_title: "Convert PNG to JPG Online Free - High Quality Image Converter",
    meta_description:
      "Convert PNG to JPG images online for free. Reduce file size while maintaining quality. Fast, secure, and no registration required. Perfect for web optimization.",
    canonical_url: "https://skyraconverter.com/png-to-jpg",
    og_title: "Free PNG to JPG Converter - Optimize Images for Web",
    og_description:
      "Transform PNG images to JPG format instantly. Reduce file size by up to 70% while keeping excellent quality. Perfect for websites, social media, and storage.",
    twitter_title: "PNG to JPG Converter - Free Online Tool",
    twitter_description:
      "Convert PNG to JPG online. Reduce image file size for web use. Fast, free, and secure conversion.",
    keywords:
      "png to jpg converter, convert png to jpg online, image format converter, reduce image size, web image optimization, free png jpg converter",
    schema_type: "SoftwareApplication",
    featured_snippet_content:
      "PNG to JPG conversion reduces file size by removing transparency and applying compression, making images web-friendly and faster to load.",
    faq_question: "How do I convert PNG to JPG online?",
    faq_answer:
      "Upload your PNG image, click convert, and download the JPG file. The process is free, fast, and maintains good image quality.",
    // Content
  },
  {
    id: 2,
    title: "png-to-pdf",
    convertion_type: "pdf",
    input_format: "png",
    type: "PNG ➝ PDF",
    p1: "Converting PNG to PDF allows you to embed an image into a document container. This is commonly used for printing, archiving, or sharing documents such as scanned signatures, forms, and photographs",
    p2: "The PDF format ensures the image remains intact and aligned in a fixed layout. This helps maintain appearance across different devices or printers, especially when consistency in formatting is important.",
    p3: "It also simplifies sharing multiple images—multiple PNGs can be combined into one PDF file, creating a single document for easier upload and transmission.",
    p4: "PDF is a universally accepted format, compatible with nearly every system. Whether you're submitting documents online or saving backups, converting PNGs to PDFs ensures professional, readable output",

    seo_title: "Convert PNG to PDF Online Free - Fast Document Converter",
    meta_description:
      "Convert PNG images to PDF online for free. Create professional documents for printing, sharing, or archiving. Fast, secure, and no registration needed.",
    canonical_url: "https://skyraconverter.com/png-to-pdf",
    og_title: "Free PNG to PDF Converter - Create Documents Easily",
    og_description:
      "Transform PNG images into PDF documents instantly. Perfect for forms, signatures, or multi-image files. Secure and optimized for all devices.",
    twitter_title: "PNG to PDF Converter - Free Online Tool",
    twitter_description:
      "Convert PNG to PDF online. Create shareable, printable documents with ease. Fast, free, and secure conversion.",
    keywords:
      "png to pdf converter, convert png to pdf online, image to document converter, create pdf from png, free png pdf converter, document optimization",
    schema_type: "SoftwareApplication",
    featured_snippet_content:
      "PNG to PDF conversion embeds images into a fixed-layout document, ideal for printing, archiving, or sharing multiple images in one file.",
    faq_question: "How do I convert PNG to PDF online?",
    faq_answer:
      "Upload your PNG image, select PDF as the output format, and download the converted file. It's free, fast, and preserves image quality.",
  },
  {
    id: 3,
    title: "png-to-svg",
    convertion_type: "svg",
    input_format: "png",
    type: "PNG ➝ SVG",
    p1: "PNG to SVG is a more complex transformation because it changes a raster image (pixels) into a vector format (paths). This is especially useful when you want to scale an image infinitely without losing clarity.",
    p2: "The process involves vector tracing, where the software outlines shapes and colors into editable paths. It's best suited for logos, icons, and simple illustrations—converting detailed photographs this way can be inaccurate or messy",
    p3: "SVG files are ideal for responsive design because they load quickly, scale well, and are editable in vector software like Adobe Illustrator or Figma. This makes them popular in web development and UI design.",
    p4: "However, not all PNGs are good candidates for conversion. Complex gradients or photographic elements don’t translate well into vector paths. For those cases, it's better to use a raster format or recreate the graphic as a true vector.",

    // SEO Properties
    seo_title: "Convert PNG to SVG Online Free - Scalable Vector Converter",
    meta_description:
      "Convert PNG to SVG online for free. Transform raster images into scalable vectors for logos, icons, and web design. Fast and accurate conversion.",
    canonical_url: "https://skyraconverter.com/png-to-svg",
    og_title: "Free PNG to SVG Converter - Perfect for Web Design",
    og_description:
      "Turn PNG images into scalable SVG vectors instantly. Ideal for logos, icons, and responsive design. No quality loss, free and secure.",
    twitter_title: "PNG to SVG Converter - Free Online Tool",
    twitter_description:
      "Convert PNG to SVG online. Create scalable vectors for web and design. Fast, free, and precise conversion.",
    keywords:
      "png to svg converter, convert png to svg online, raster to vector converter, scalable image converter, free png svg converter, vector graphics",
    schema_type: "SoftwareApplication",
    featured_snippet_content:
      "PNG to SVG conversion transforms raster images into scalable vectors, perfect for logos and icons that need to resize without losing quality.",
    faq_question: "How do I convert PNG to SVG online?",
    faq_answer:
      "Upload your PNG, select SVG output, and let the tool trace the image into a vector format. Download the scalable SVG file instantly.",
  },
  {
    id: 4,
    title: "png-to-jpeg",
    convertion_type: "jpeg",
    input_format: "png",
    type: "PNG ➝ JPEG",
    p1: "PNG to JPEG conversion is similar to PNG to JPG, as JPEG and JPG are functionally identical. The main difference lies in the file extension—.jpeg is used in some systems due to naming conventions or compatibility with older software.",
    p2: "The conversion reduces the size of the image while slightly sacrificing quality. PNGs are great for storing high-quality images with crisp details and transparency, but for general image sharing and storage, JPEGs are more efficient.",
    p3: "JPEGs do not support transparency, so any see-through areas in the PNG will be filled. This is acceptable for standard use cases where the image background doesn’t need to be manipulated post-conversion.",
    p4: "Overall, converting PNG to JPEG makes your images more flexible and lighter for everyday use. It's beneficial for online uploads, emails, and embedding in websites or documents where smaller file sizes improve performance.",

    // SEO Properties
    seo_title: "Convert PNG to JPEG Online Free - Optimize Images Easily",
    meta_description:
      "Convert PNG to JPEG online for free. Reduce file size while maintaining quality. Fast, secure, and perfect for web and email use.",
    canonical_url: "https://skyraconverter.com/png-to-jpeg",
    og_title: "Free PNG to JPEG Converter - Web-Optimized Images",
    og_description:
      "Transform PNG images to JPEG format instantly. Save space and optimize for web, email, or storage. Free and secure conversion.",
    twitter_title: "PNG to JPEG Converter - Free Online Tool",
    twitter_description:
      "Convert PNG to JPEG online. Shrink image sizes for faster uploads and web use. Free, secure, and easy.",
    keywords:
      "png to jpeg converter, convert png to jpeg online, image format converter, optimize images for web, free png jpeg converter, reduce image size",
    schema_type: "SoftwareApplication",
    featured_snippet_content:
      "PNG to JPEG conversion reduces file size by removing transparency, making images ideal for web, email, and general sharing.",
    faq_question: "How do I convert PNG to JPEG online?",
    faq_answer:
      "Upload your PNG image, select JPEG as the output format, and download the converted file. It's fast, free, and maintains good quality.",
  },
  {
    id: 5,
    title: "png-to-webp",
    convertion_type: "webp",
    input_format: "png",
    type: "PNG ➝ WEBP",
    p1: "PNG to WebP is a smart conversion if you're looking to keep quality while drastically reducing file size. WebP, developed by Google, supports both lossless and lossy compression and is specifically optimized for the web.",
    p2: "Unlike JPG, WebP retains transparency like PNG while still shrinking file size significantly. This makes it a fantastic alternative for UI images, product photos, and icons used on websites or mobile apps.",
    p3: "Smaller file sizes lead to faster page load times, better SEO scores, and improved user experiences—especially on slower internet connections or data-limited mobile devices.",
    p4: "WebP is supported by most modern browsers, though it’s always good to provide a fallback image for full compatibility. It’s the go-to choice for developers aiming to modernize and optimize websites.",
    // SEO Properties
    seo_title: "Convert PNG to WebP Online Free - Web-Optimized Images",
    meta_description:
      "Convert PNG to WebP online for free. Get smaller file sizes with transparency support. Perfect for fast-loading websites and apps.",
    canonical_url: "https://skyraconverter.com/png-to-webp",
    og_title: "Free PNG to WebP Converter - Optimize for Web",
    og_description:
      "Transform PNG images to WebP for smaller sizes and faster load times. Ideal for websites, apps, and SEO. Free and secure.",
    twitter_title: "PNG to WebP Converter - Free Online Tool",
    twitter_description:
      "Convert PNG to WebP online. Optimize images for web with transparency support. Fast, free, and secure.",
    keywords:
      "png to webp converter, convert png to webp online, web image optimization, reduce image size, free png webp converter, webp for websites",
    schema_type: "SoftwareApplication",
    featured_snippet_content:
      "PNG to WebP conversion reduces file size while retaining transparency, ideal for fast-loading websites and mobile apps.",
    faq_question: "How do I convert PNG to WebP online?",
    faq_answer:
      "Upload your PNG, select WebP as the output, and download the optimized file. It's free, fast, and retains transparency.",
  },
  {
    id: 6,
    title: "png-to-tiff",
    convertion_type: "tiff",
    input_format: "png",
    type: "PNG ➝ TIFF",
    p1: "When converting PNG to TIFF, you're moving to a high-fidelity format used in publishing and archival workflows. TIFF is often used in professional photography, medical imaging, and print production",
    p2: "Unlike WebP or JPG, TIFF supports lossless compression, layers, and metadata. It’s perfect for preserving the image’s highest quality for editing or storage without losing detail.",
    p3: "TIFFs are not web-friendly due to their size and limited browser support, but they excel in environments where accuracy and color depth matter—like book printing or scanning.",
    p4: "This format is ideal when you want to retain full-quality source images for editing, archiving, or printing. If you're preparing materials for long-term storage or commercial printing, this conversion is the right step",

    // SEO Properties
    seo_title: "Convert PNG to TIFF Online Free - High-Quality Image Converter",
    meta_description:
      "Convert PNG to TIFF online for free. Preserve image quality for printing, archiving, or editing. Fast, secure, and no registration needed.",
    canonical_url: "https://skyraconverter.com/png-to-tiff",
    og_title: "Free PNG to TIFF Converter - Professional Image Quality",
    og_description:
      "Transform PNG images to TIFF for lossless quality. Perfect for printing, archiving, and professional workflows. Free and secure.",
    twitter_title: "PNG to TIFF Converter - Free Online Tool",
    twitter_description:
      "Convert PNG to TIFF online. Retain full image quality for printing and archiving. Fast, free, and secure.",
    keywords:
      "png to tiff converter, convert png to tiff online, high-quality image converter, lossless image format, free png tiff converter, image for printing",
    schema_type: "SoftwareApplication",
    featured_snippet_content:
      "PNG to TIFF conversion preserves image quality with lossless compression, ideal for professional printing and archiving.",
    faq_question: "How do I convert PNG to TIFF online?",
    faq_answer:
      "Upload your PNG image, select TIFF as the output format, and download the high-quality file. It's free and fast.",
  },
  {
    id: 7,
    title: "png-to-avif",
    convertion_type: "avif",
    input_format: "png",
    type: "PNG ➝ AVIF",
    p1: "AVIF is a modern, highly efficient image format. Converting PNG to AVIF results in drastically smaller file sizes while maintaining quality—especially with high-resolution images.",
    p2: "AVIF supports transparency, like PNG, making it a great replacement for web and mobile content. It's especially beneficial when targeting performance without sacrificing visual appearance.",
    p3: "This format also supports HDR and deep color depth, making it great for photography, app backgrounds, and UI elements. Its ability to compress images better than even WebP is a major strength.",
    p4: "While browser and software support is still growing, AVIF is rapidly becoming a favorite for developers and designers who need sleek, fast-loading visuals with modern capabilities.",

    // SEO Properties
    seo_title: "Convert PNG to AVIF Online Free - Next-Gen Image Converter",
    meta_description:
      "Convert PNG to AVIF online for free. Get smaller, high-quality images with transparency support. Perfect for modern web and apps.",
    canonical_url: "https://skyraconverter.com/png-to-avif",
    og_title: "Free PNG to AVIF Converter - Optimize for Future Web",
    og_description:
      "Transform PNG images to AVIF for superior compression and quality. Ideal for web, apps, and HDR visuals. Free and secure.",
    twitter_title: "PNG to AVIF Converter - Free Online Tool",
    twitter_description:
      "Convert PNG to AVIF online. Optimize images for web with transparency and HDR. Fast, free, and secure.",
    keywords:
      "png to avif converter, convert png to avif online, next-gen image converter, reduce image size, free png avif converter, avif for web",
    schema_type: "SoftwareApplication",
    featured_snippet_content:
      "PNG to AVIF conversion offers smaller file sizes with transparency and HDR support, perfect for modern web and mobile apps.",
    faq_question: "How do I convert PNG to AVIF online?",
    faq_answer:
      "Upload your PNG, select AVIF as the output, and download the optimized file. It's free, fast, and supports transparency.",
  },
  {
    id: 8,
    title: "png-to-heic",
    convertion_type: "heic",
    input_format: "png",
    type: "PNG ➝ HEIC",
    p1: "When converting PNG to HEIC, you're transitioning to a highly efficient image format designed for modern devices and applications. HEIC (High Efficiency Image Codec) offers advanced compression while retaining excellent image quality, making it perfect for storage-conscious environments.",
    p2: "Unlike PNG, which is widely used for transparency and crisp quality, HEIC significantly reduces file size using advanced compression algorithms without sacrificing detail. This makes it ideal for mobile devices, cloud storage, and fast sharing.",
    p3: "HEIC files are commonly used across iOS and macOS systems, especially in Apple's Photos app. While it’s not universally supported by all platforms yet, HEIC is gaining traction for its efficiency and future-readiness.",
    p4: "Choose this conversion when you want to maintain visual fidelity while reducing file size. It’s especially useful for users who work with high-quality visuals but need to optimize space, such as in mobile photography or app development.",

    // SEO Properties
    seo_title: "Convert PNG to HEIC Online Free - Efficient Image Converter",
    meta_description:
      "Convert PNG to HEIC online for free. Save space with high-quality images. Perfect for iOS, macOS, and mobile storage optimization.",
    canonical_url: "https://skyraconverter.com/png-to-heic",
    og_title: "Free PNG to HEIC Converter - Optimize for Mobile",
    og_description:
      "Transform PNG images to HEIC for smaller sizes and great quality. Ideal for iOS, macOS, and mobile use. Free and secure.",
    twitter_title: "PNG to HEIC Converter - Free Online Tool",
    twitter_description:
      "Convert PNG to HEIC online. Optimize images for mobile and storage. Fast, free, and high-quality conversion.",
    keywords:
      "png to heic converter, convert png to heic online, efficient image converter, mobile image optimization, free png heic converter, heic for ios",
    schema_type: "SoftwareApplication",
    featured_snippet_content:
      "PNG to HEIC conversion reduces file size with advanced compression, ideal for mobile storage and iOS/macOS compatibility.",
    faq_question: "How do I convert PNG to HEIC online?",
    faq_answer:
      "Upload your PNG image, select HEIC as the output format, and download the compressed file. It's free and fast.",
  },
  {
    id: 9,
    title: "jpg-to-png",
    convertion_type: "png",
    input_format: "jpg",
    type: "JPG ➝ PNG",
    p1: "Converting JPG to PNG is a common step for users wanting to avoid repeated compression loss. While JPG is a lossy format, PNG preserves the image as-is during save operations. So, this conversion is often used in editing workflows where maintaining image quality during revisions is key.",
    p2: " PNG also introduces support for transparency, which JPG lacks. Designers and developers often convert JPG to PNG when they need to remove or modify backgrounds, or incorporate the image into compositions requiring layered transparency",
    p3: "Although PNG files are larger, this tradeoff is acceptable when transparency or quality retention is more important than file size. This makes PNG suitable for logos, digital artwork, UI elements, and application assets.",
    p4: "For app developers and content creators, PNG is the go-to format when there's a need for precision and visual clarity—especially when exporting screenshots, design assets, or preparing visuals for responsive UI environments.",

    // SEO Properties
    seo_title: "Convert JPG to PNG Online Free - Preserve Image Quality",
    meta_description:
      "Convert JPG to PNG online for free. Add transparency and preserve quality for editing or design. Fast, secure, and no registration needed.",
    canonical_url: "https://skyraconverter.com/jpg-to-png",
    og_title: "Free JPG to PNG Converter - Perfect for Design",
    og_description:
      "Transform JPG images to PNG with transparency support. Ideal for logos, UI, and editing. Free, secure, and high-quality.",
    twitter_title: "JPG to PNG Converter - Free Online Tool",
    twitter_description:
      "Convert JPG to PNG online. Add transparency and maintain quality for design. Fast, free, and secure.",
    keywords:
      "jpg to png converter, convert jpg to png online, image transparency converter, preserve image quality, free jpg png converter, design assets",
    schema_type: "SoftwareApplication",
    featured_snippet_content:
      "JPG to PNG conversion preserves image quality and adds transparency, ideal for editing, logos, and UI design.",
    faq_question: "How do I convert JPG to PNG online?",
    faq_answer:
      "Upload your JPG image, select PNG as the output format, and download the file with transparency support. It's free and fast.",
  },
  {
    id: 10,
    title: "jpg-to-pdf",
    convertion_type: "pdf",
    input_format: "jpg",
    type: "JPG ➝ PDF",
    p1: " Converting a JPG to PDF is one of the most common document conversions. It is often used in  digitizing paperwork, converting scanned forms or images of documents into a format that can be submitted, printed, or stored easily.",
    p2: "This format change ensures that layout and alignment are preserved, making it suitable for official purposes like applications, reports, or certificates. PDF is platform-independent and opens uniformly across devices",
    p3: "Another benefit is bundling—multiple JPGs can be combined into one PDF file, which is particularly useful for creating portfolios, presentations, or eBooks. This reduces the need for image viewers and makes sharing and viewing easier for recipients.",
    p4: " PDFs can also be password-protected or digitally signed, adding a layer of security that image formats lack. This makes the conversion ideal for administrative workflows, digital archiving, and secure sharing.",

    // SEO Properties
    seo_title: "Convert JPG to PDF Online Free - Create Professional Documents",
    meta_description:
      "Convert JPG to PDF online for free. Create secure, shareable documents for printing or archiving. Fast and no registration needed.",
    canonical_url: "https://skyraconverter.com/jpg-to-pdf",
    og_title: "Free JPG to PDF Converter - Easy Document Creation",
    og_description:
      "Transform JPG images into PDF documents instantly. Perfect for forms, reports, or portfolios. Free, secure, and reliable.",
    twitter_title: "JPG to PDF Converter - Free Online Tool",
    twitter_description:
      "Convert JPG to PDF online. Create professional documents for sharing or printing. Fast, free, and secure.",
    keywords:
      "jpg to pdf converter, convert jpg to pdf online, image to document converter, create pdf from jpg, free jpg pdf converter, document sharing",
    schema_type: "SoftwareApplication",
    featured_snippet_content:
      "JPG to PDF conversion creates professional documents from images, ideal for printing, archiving, or bundling multiple files.",
    faq_question: "How do I convert JPG to PDF online?",
    faq_answer:
      "Upload your JPG image, select PDF as the output, and download the document. It's free, fast, and supports multiple images.",
  },
  {
    id: 11,
    title: "jpg-to-svg",
    convertion_type: "svg",
    input_format: "jpg",
    type: "JPG ➝ SVG",
    p1: "The JPG to SVG conversion involves a transformation from raster (pixel-based) to vector (path-based) format. This is typically done using vector tracing tools or software that converts visible shapes into scalable lines and curves.",
    p2: " SVGs shine in scalability; once a JPG is converted to SVG, it can be resized to any dimension without pixelation, making it perfect for icons, logos, and simplified graphics. However, detailed photographs don’t convert well and may result in distorted vectors",
    p3: "This conversion is more suitable for stylized graphics, sketches, and flat art rather than real-world imagery. Designers use it to create high-resolution-independent assets that retain their quality across mobile, desktop, and print resolutions.",
    p4: "SVG files are lightweight and editable via code or design software, making them ideal for web environments. They can even include interactive elements or animations, which adds extra usability that raster images don’t offer.",

    // SEO Properties
    seo_title: "Convert JPG to SVG Online Free - Scalable Vector Graphics",
    meta_description:
      "Convert JPG to SVG online for free. Create scalable vectors for logos, icons, and web design. Fast, accurate, and no registration needed.",
    canonical_url: "https://skyraconverter.com/jpg-to-svg",
    og_title: "Free JPG to SVG Converter - Perfect for Designers",
    og_description:
      "Transform JPG images to SVG vectors for scalable graphics. Ideal for logos, icons, and responsive design. Free and secure.",
    twitter_title: "JPG to SVG Converter - Free Online Tool",
    twitter_description:
      "Convert JPG to SVG online. Create scalable vectors for web and design. Fast, free, and precise.",
    keywords:
      "jpg to svg converter, convert jpg to svg online, raster to vector converter, scalable graphics, free jpg svg converter, vector design",
    schema_type: "SoftwareApplication",
    featured_snippet_content:
      "JPG to SVG conversion transforms raster images into scalable vectors, ideal for logos and icons in web and print design.",
    faq_question: "How do I convert JPG to SVG online?",
    faq_answer:
      "Upload your JPG, select SVG output, and let the tool trace the image into a vector format. Download the scalable SVG instantly.",
  },
  {
    id: 12,
    title: "jpg-to-jpeg",
    convertion_type: "jpeg",
    input_format: "jpg",
    type: "JPG ➝ JPEG",
    p1: " Converting JPG to JPEG is essentially a file renaming task, as both formats are technically identical in structure and compression method. The primary difference lies in the file extension, which can sometimes cause issues with older operating systems or specialized software expecting one over the other.",
    p2: " This renaming can be useful in batch-processing pipelines or automation workflows where uniform file extensions reduce the chance of errors. Standardization ensures better compatibility across operating systems, especially when shared across multiple platforms or software types",
    p3: " There’s no actual change in image quality or format behavior with this conversion—it’s purely about extension compatibility. Some users may prefer .jpeg for organizational or naming conventions, especially when preparing files for publishing, uploading, or exporting.",
    p4: "Despite being functionally identical, making the switch helps maintain consistency across an image repository and may prevent unexpected incompatibility warnings during automated uploads or image handling scripts.",

    // SEO Properties
    seo_title: "Convert JPG to JPEG Online Free - Standardize Image Extensions",
    meta_description:
      "Convert JPG to JPEG online for free. Standardize file extensions for compatibility. Fast, secure, and no quality loss.",
    canonical_url: "https://skyraconverter.com/jpg-to-jpeg",
    og_title: "Free JPG to JPEG Converter - Ensure Compatibility",
    og_description:
      "Rename JPG to JPEG instantly for consistent file extensions. Perfect for automation and compatibility. Free and secure.",
    twitter_title: "JPG to JPEG Converter - Free Online Tool",
    twitter_description:
      "Convert JPG to JPEG online. Standardize extensions for compatibility. Fast, free, and secure.",
    keywords:
      "jpg to jpeg converter, convert jpg to jpeg online, standardize image extensions, image compatibility, free jpg jpeg converter, file renaming",
    schema_type: "SoftwareApplication",
    featured_snippet_content:
      "JPG to JPEG conversion renames files for compatibility, maintaining identical quality and compression for seamless use.",
    faq_question: "How do I convert JPG to JPEG online?",
    faq_answer:
      "Upload your JPG image, select JPEG as the output, and download the renamed file. It's free, fast, and quality-preserving.",
  },
  {
    id: 13,
    title: "jpg-to-webp",
    convertion_type: "webp",
    input_format: "jpg",
    type: "JPG ➝ WEBP",
    p1: " Converting JPG to WebP offers significant file size reduction without a noticeable loss in quality. This makes it ideal for websites and apps that demand fast loading times and minimal bandwidth usage.",
    p2: " WebP supports both lossy and lossless compression, unlike JPG, which is purely lossy. This flexibility lets developers choose the best balance between quality and performance for their specific use case.",
    p3: " In addition, WebP supports transparency (alpha channel), which JPG lacks. This makes it a versatile replacement for both PNG and JPG in modern web development, especially for UI elements, backgrounds, and icons.",
    p4: "The growing adoption of WebP by browsers and CMS platforms makes this conversion a future-proof step in optimizing digital assets. It’s particularly useful in mobile-first design, where speed and bandwidth are critical.",

    // SEO Properties
    seo_title: "Convert JPG to WebP Online Free - Optimize Web Images",
    meta_description:
      "Convert JPG to WebP online for free. Reduce file size with transparency support for faster websites and apps. Secure and easy.",
    canonical_url: "https://skyraconverter.com/jpg-to-webp",
    og_title: "Free JPG to WebP Converter - Boost Web Performance",
    og_description:
      "Transform JPG images to WebP for smaller sizes and faster load times. Perfect for websites and apps. Free and secure.",
    twitter_title: "JPG to WebP Converter - Free Online Tool",
    twitter_description:
      "Convert JPG to WebP online. Optimize images for web with transparency. Fast, free, and secure.",
    keywords:
      "jpg to webp converter, convert jpg to webp online, web image optimization, reduce image size, free jpg webp converter, webp for websites",
    schema_type: "SoftwareApplication",
    featured_snippet_content:
      "JPG to WebP conversion reduces file size with transparency support, ideal for faster websites and mobile apps.",
    faq_question: "How do I convert JPG to WebP online?",
    faq_answer:
      "Upload your JPG, select WebP as the output, and download the optimized file. It's free, fast, and supports transparency.",
  },
  {
    id: 14,
    title: "jpg-to-tiff",
    convertion_type: "tiff",
    input_format: "jpg",
    type: "JPG ➝ TIFF",
    p1: " Converting JPG to TIFF is a common practice in professional photography and printing. JPG images, which may have already been compressed, are saved as TIFFs to preserve current quality and enable non-destructive editing.",
    p2: " TIFF supports high bit-depth and multiple color channels, making it ideal for image correction, retouching, and printing workflows. Unlike JPG, TIFF does not compress data in a lossy manner, so future saves do not degrade quality.",
    p3: " This format also supports layers and metadata, making it useful in design software like Photoshop and for industries that rely on archiving image history and editing steps.",
    p4: " TIFFs are large in size, but they’re the preferred format for museum-grade digital scans, medical imaging, and professional media production. They serve as a long-term, high-fidelity format for archival and publishing needs.",

    // SEO Properties
    seo_title: "Convert JPG to TIFF Online Free - Preserve Image Quality",
    meta_description:
      "Convert JPG to TIFF online for free. Retain quality for printing, archiving, or editing. Fast, secure, and no registration needed.",
    canonical_url: "https://skyraconverter.com/jpg-to-tiff",
    og_title: "Free JPG to TIFF Converter - Professional Image Format",
    og_description:
      "Transform JPG images to TIFF for lossless quality. Ideal for printing, archiving, and professional workflows. Free and secure.",
    twitter_title: "JPG to TIFF Converter - Free Online Tool",
    twitter_description:
      "Convert JPG to TIFF online. Preserve quality for printing and archiving. Fast, free, and secure.",
    keywords:
      "jpg to tiff converter, convert jpg to tiff online, high-quality image converter, lossless image format, free jpg tiff converter, image for printing",
    schema_type: "SoftwareApplication",
    featured_snippet_content:
      "JPG to TIFF conversion preserves image quality with lossless compression, ideal for professional printing and archiving.",
    faq_question: "How do I convert JPG to TIFF online?",
    faq_answer:
      "Upload your JPG image, select TIFF as the output format, and download the high-quality file. It's free and fast.",
  },
  {
    id: 15,
    title: "jpg-to-avif",
    convertion_type: "avif",
    input_format: "jpg",
    type: "JPG ➝ AVIF",
    p1: "AVIF is one of the most advanced modern formats, offering superior compression and image quality. Converting JPG to AVIF drastically reduces file size while preserving or even enhancing perceptual quality.",
    p2: " It’s especially beneficial for websites and mobile apps where speed and storage efficiency are crucial. The format supports features like HDR, transparency, and wide color gamut—making it more powerful than JPG.",
    p3: "AVIF’s efficient compression is ideal for visual media platforms, ecommerce websites, or any application where high performance and excellent visuals must coexist. It provides better efficiency than WebP and better quality than JPG for the same size.",
    p4: " Though not universally supported yet, AVIF is gaining momentum across modern platforms and browsers. Converting JPGs to AVIF is a smart move for future-proofing media assets and optimizing digital experiences.",

    // SEO Properties
    seo_title: "Convert JPG to AVIF Online Free - Advanced Image Converter",
    meta_description:
      "Convert JPG to AVIF online for free. Get smaller, high-quality images with HDR support. Perfect for modern web and apps.",
    canonical_url: "https://skyraconverter.com/jpg-to-avif",
    og_title: "Free JPG to AVIF Converter - Optimize for Future Web",
    og_description:
      "Transform JPG images to AVIF for superior compression and quality. Ideal for web, apps, and HDR visuals. Free and secure.",
    twitter_title: "JPG to AVIF Converter - Free Online Tool",
    twitter_description:
      "Convert JPG to AVIF online. Optimize images for web with HDR and transparency. Fast, free, and secure.",
    keywords:
      "jpg to avif converter, convert jpg to avif online, next-gen image converter, reduce image size, free jpg avif converter, avif for web",
    schema_type: "SoftwareApplication",
    featured_snippet_content:
      "JPG to AVIF conversion offers smaller file sizes with HDR and transparency support, perfect for modern web and apps.",
    faq_question: "How do I convert JPG to AVIF online?",
    faq_answer:
      "Upload your JPG, select AVIF as the output, and download the optimized file. It's free, fast, and supports advanced features.",
  },
  {
    id: 16,
    title: "jpg-to-heic",
    convertion_type: "heic",
    input_format: "jpg",
    type: "JPG ➝ HEIC",
    p1: "Switching from JPG to HEIC helps modernize your image storage by reducing file size while enhancing visual quality. HEIC’s efficiency is ideal for minimizing storage usage without the quality loss often associated with JPG.",
    p2: "JPG is one of the most common image formats but uses lossy compression that can degrade image clarity. HEIC, on the other hand, uses advanced methods that keep images sharp and clear even after compression.",
    p3: "HEIC is especially beneficial for users on iPhones, iPads, or Macs, as it's fully supported within the Apple ecosystem. Although not all platforms support it natively, many tools now offer compatibility or conversion options",
    p4: "This conversion is recommended when you're optimizing images for modern use, especially in mobile environments. It’s a smart choice for users who want smaller files without compromising on image integrity.",

    // SEO Properties
    seo_title: "Convert JPG to HEIC Online Free - Efficient Image Converter",
    meta_description:
      "Convert JPG to HEIC online for free. Save space with high-quality images. Perfect for iOS, macOS, and mobile optimization.",
    canonical_url: "https://skyraconverter.com/jpg-to-heic",
    og_title: "Free JPG to HEIC Converter - Optimize for Mobile",
    og_description:
      "Transform JPG images to HEIC for smaller sizes and great quality. Ideal for iOS, macOS, and mobile use. Free and secure.",
    twitter_title: "JPG to HEIC Converter - Free Online Tool",
    twitter_description:
      "Convert JPG to HEIC online. Optimize images for mobile and storage. Fast, free, and high-quality conversion.",
    keywords:
      "jpg to heic converter, convert jpg to heic online, efficient image converter, mobile image optimization, free jpg heic converter, heic for ios",
    schema_type: "SoftwareApplication",
    featured_snippet_content:
      "JPG to HEIC conversion reduces file size with advanced compression, ideal for mobile storage and iOS/macOS compatibility.",
    faq_question: "How do I convert JPG to HEIC online?",
    faq_answer:
      "Upload your JPG image, select HEIC as the output format, and download the compressed file. It's free and fast.",
  },
  {
    id: 17,
    title: "jpeg-to-png",
    convertion_type: "png",
    input_format: "jpeg",
    type: "JPEG ➝ PNG",
    p1: "JPEG to PNG conversion is great when you want to edit the image or preserve its current quality. Since PNG is lossless, you avoid introducing further degradation during saves or edits.",
    p2: "This is helpful in workflows where transparency is needed—something JPEG doesn’t support. For instance, you can make part of an image transparent for overlay purposes after converting to PNG.",
    p3: "Although the file size will increase, PNGs offer better preservation of image detail during multiple edits. This makes it ideal for digital artists and designers.",
    p4: "It’s not meant for reducing size but for preserving fidelity and enabling transparency or layered work in creative projects.",

    // SEO Properties
    seo_title: "Convert JPEG to PNG Online Free - Preserve Image Quality",
    meta_description:
      "Convert JPEG to PNG online for free. Add transparency and preserve quality for editing or design. Fast, secure, and easy.",
    canonical_url: "https://skyraconverter.com/jpeg-to-png",
    og_title: "Free JPEG to PNG Converter - Perfect for Design",
    og_description:
      "Transform JPEG images to PNG with transparency support. Ideal for logos, UI, and editing. Free, secure, and high-quality.",
    twitter_title: "JPEG to PNG Converter - Free Online Tool",
    twitter_description:
      "Convert JPEG to PNG online. Add transparency and maintain quality for design. Fast, free, and secure.",
    keywords:
      "jpeg to png converter, convert jpeg to png online, image transparency converter, preserve image quality, free jpeg png converter, design assets",
    schema_type: "SoftwareApplication",
    featured_snippet_content:
      "JPEG to PNG conversion preserves image quality and adds transparency, ideal for editing, logos, and UI design.",
    faq_question: "How do I convert JPEG to PNG online?",
    faq_answer:
      "Upload your JPEG image, select PNG as the output format, and download the file with transparency support. It's free and fast.",
  },
  {
    id: 18,
    title: "jpeg-to-pdf",
    convertion_type: "pdf",
    input_format: "jpeg",
    type: "JPEG ➝ PDF",
    p1: "This conversion embeds your JPEG into a document format, useful for reports, records, or official submissions. It ensures consistent layout and print readiness.",
    p2: "PDFs are compatible with virtually all devices and operating systems. They're preferred for archiving, printing, and file submission processes in both academic and professional settings.",
    p3: "Converting to PDF also allows bundling multiple JPEGs into one document. This is helpful when compiling photo albums, certificates, or ID proofs into a single file.",
    p4: "It ensures that your visual content remains unaltered during transmission, with no risk of quality loss due to compression or reformatting by external tools.",

    // SEO Properties
    seo_title:
      "Convert JPEG to PDF Online Free - Create Professional Documents",
    meta_description:
      "Convert JPEG to PDF online for free. Create secure, shareable documents for printing or archiving. Fast and no registration needed.",
    canonical_url: "https://skyraconverter.com/jpeg-to-pdf",
    og_title: "Free JPEG to PDF Converter - Easy Document Creation",
    og_description:
      "Transform JPEG images into PDF documents instantly. Perfect for forms, reports, or portfolios. Free, secure, and reliable.",
    twitter_title: "JPEG to PDF Converter - Free Online Tool",
    twitter_description:
      "Convert JPEG to PDF online. Create professional documents for sharing or printing. Fast, free, and secure.",
    keywords:
      "jpeg to pdf converter, convert jpeg to pdf online, image to document converter, create pdf from jpeg, free jpeg pdf converter, document sharing",
    schema_type: "SoftwareApplication",
    featured_snippet_content:
      "JPEG to PDF conversion creates professional documents from images, ideal for printing, archiving, or bundling multiple files.",
    faq_question: "How do I convert JPEG to PDF online?",
    faq_answer:
      "Upload your JPEG image, select PDF as the output, and download the document. It's free, fast, and supports multiple images.",
  },
  {
    id: 19,
    title: "jpeg-to-svg",
    convertion_type: "svg",
    input_format: "jpeg",
    type: "JPEG ➝ SVG",
    p1: "This conversion vectorizes a raster image, turning it into scalable paths. It's done by tracing the outlines of shapes and colors to create a simplified version of the original image.",
    p2: "It works best on graphics, logos, or illustrations with clear boundaries and few colors. Photographic JPEGs don’t translate well and may appear distorted or over-simplified.",
    p3: "Once converted, SVGs can be scaled indefinitely without loss in quality. They’re editable in vector-based tools and perfect for responsive design.",
    p4: "While the conversion is not perfect for all JPEGs, it offers a way to repurpose image assets for logos, UI icons, or stylized representations on the web.",

    // SEO Properties
    seo_title: "Convert JPEG to SVG Online Free - Scalable Vector Graphics",
    meta_description:
      "Convert JPEG to SVG online for free. Create scalable vectors for logos, icons, and web design. Fast, accurate, and no registration needed.",
    canonical_url: "https://skyraconverter.com/jpeg-to-svg",
    og_title: "Free JPEG to SVG Converter - Perfect for Designers",
    og_description:
      "Transform JPEG images to SVG vectors for scalable graphics. Ideal for logos, icons, and responsive design. Free and secure.",
    twitter_title: "JPEG to SVG Converter - Free Online Tool",
    twitter_description:
      "Convert JPEG to SVG online. Create scalable vectors for web and design. Fast, free, and precise.",
    keywords:
      "jpeg to svg converter, convert jpeg to svg online, raster to vector converter, scalable graphics, free jpeg svg converter, vector design",
    schema_type: "SoftwareApplication",
    featured_snippet_content:
      "JPEG to SVG conversion transforms raster images into scalable vectors, ideal for logos and icons in web and print design.",
    faq_question: "How do I convert JPEG to SVG online?",
    faq_answer:
      "Upload your JPEG, select SVG output, and let the tool trace the image into a vector format. Download the scalable SVG instantly.",
  },
  {
    id: 20,
    title: "jpeg-to-jpg",
    convertion_type: "jpg",
    input_format: "jpeg",
    type: "JPEG ➝ JPG",
    p1: "JPEG and JPG are the same format—just different names. JPG was the original Windows-compatible version due to three-letter file extension limits. Nowadays, they are used interchangeably.",
    p2: "This conversion is essentially a renaming, useful for consistency across systems or when adhering to naming standards in automation or CMS platforms.",
    p3: "Some legacy systems, particularly in older content management tools, may accept only one extension. So renaming JPEG to JPG ensures broader compatibility.",
    p4: "There is no quality change, data loss, or visual difference during this conversion. It's simply for organization, consistency, or software requirements.",

    // SEO Properties
    seo_title: "Convert JPEG to JPG Online Free - Standardize Image Extensions",
    meta_description:
      "Convert JPEG to JPG online for free. Standardize file extensions for compatibility. Fast, secure, and no quality loss.",
    canonical_url: "https://skyraconverter.com/jpeg-to-jpg",
    og_title: "Free JPEG to JPG Converter - Ensure Compatibility",
    og_description:
      "Rename JPEG to JPG instantly for consistent file extensions. Perfect for automation and compatibility. Free and secure.",
    twitter_title: "JPEG to JPG Converter - Free Online Tool",
    twitter_description:
      "Convert JPEG to JPG online. Standardize extensions for compatibility. Fast, free, and secure.",
    keywords:
      "jpeg to jpg converter, convert jpeg to jpg online, standardize image extensions, image compatibility, free jpeg jpg converter, file renaming",
    schema_type: "SoftwareApplication",
    featured_snippet_content:
      "JPEG to JPG conversion renames files for compatibility, maintaining identical quality and compression for seamless use.",
    faq_question: "How do I convert JPEG to JPG online?",
    faq_answer:
      "Upload your JPEG image, select JPG as the output, and download the renamed file. It's free, fast, and quality-preserving.",
  },
  {
    id: 21,
    title: "jpeg-to-webp",
    convertion_type: "webp",
    input_format: "jpeg",
    type: "JPEG ➝ WEBP",
    p1: "JPEG to WebP is excellent for modern web use. WebP provides better compression, reducing the size significantly while retaining visual quality.",
    p2: "This means faster load times, less bandwidth usage, and quicker rendering—especially useful for blogs, eCommerce platforms, and mobile apps.",
    p3: "WebP supports both lossy and lossless compression, along with metadata and animation capabilities. It’s a more flexible format than JPEG for developers.",
    p4: "WebP has become the preferred format for online assets where performance and visual integrity are important. Converting legacy JPEGs to WebP is a smart optimization step.",

    // SEO Properties
    seo_title: "Convert JPEG to WebP Online Free - Optimize Web Images",
    meta_description:
      "Convert JPEG to WebP online for free. Reduce file size with transparency support for faster websites and apps. Secure and easy.",
    canonical_url: "https://skyraconverter.com/jpeg-to-webp",
    og_title: "Free JPEG to WebP Converter - Boost Web Performance",
    og_description:
      "Transform JPEG images to WebP for smaller sizes and faster load times. Perfect for websites and apps. Free and secure.",
    twitter_title: "JPEG to WebP Converter - Free Online Tool",
    twitter_description:
      "Convert JPEG to WebP online. Optimize images for web with transparency. Fast, free, and secure.",
    keywords:
      "jpeg to webp converter, convert jpeg to webp online, web image optimization, reduce image size, free jpeg webp converter, webp for websites",
    schema_type: "SoftwareApplication",
    featured_snippet_content:
      "JPEG to WebP conversion reduces file size with transparency support, ideal for faster websites and mobile apps.",
    faq_question: "How do I convert JPEG to WebP online?",
    faq_answer:
      "Upload your JPEG, select WebP as the output, and download the optimized file. It's free, fast, and supports transparency.",
  },
  {
    id: 22,
    title: "jpeg-to-tiff",
    convertion_type: "tiff",
    input_format: "jpeg",
    type: "JPEG ➝ TIFF",
    p1: "Converting JPEG to TIFF is ideal when you want to preserve image quality and begin a non-destructive editing workflow. TIFFs support lossless storage.",
    p2: "While JPEGs lose quality with each save, TIFFs retain full resolution and color depth, which is important in photography, design, and scanning tasks.",
    p3: "TIFFs also support layers and alpha channels, allowing for more advanced editing than JPEGs. This makes them perfect for Photoshop workflows and publishing pipelines.",
    p4: "Though larger in size, TIFFs are the preferred choice in industries that prioritize image fidelity over storage efficiency.",

    // SEO Properties
    seo_title: "Convert JPEG to TIFF Online Free - Preserve Image Quality",
    meta_description:
      "Convert JPEG to TIFF online for free. Retain quality for printing, archiving, or editing. Fast, secure, and no registration needed.",
    canonical_url: "https://skyraconverter.com/jpeg-to-tiff",
    og_title: "Free JPEG to TIFF Converter - Professional Image Format",
    og_description:
      "Transform JPEG images to TIFF for lossless quality. Ideal for printing, archiving, and professional workflows. Free and secure.",
    twitter_title: "JPEG to TIFF Converter - Free Online Tool",
    twitter_description:
      "Convert JPEG to TIFF online. Preserve quality for printing and archiving. Fast, free, and secure.",
    keywords:
      "jpeg to tiff converter, convert jpeg to tiff online, high-quality image converter, lossless image format, free jpeg tiff converter, image for printing",
    schema_type: "SoftwareApplication",
    featured_snippet_content:
      "JPEG to TIFF conversion preserves image quality with lossless compression, ideal for professional printing and archiving.",
    faq_question: "How do I convert JPEG to TIFF online?",
    faq_answer:
      "Upload your JPEG image, select TIFF as the output format, and download the high-quality file. It's free and fast.",
  },
  {
    id: 23,
    title: "jpeg-to-avif",
    convertion_type: "avif",
    input_format: "jpeg",
    type: "JPEG ➝ AVIF",
    p1: "JPEG to AVIF conversion brings modern compression and performance to older image libraries. AVIF produces smaller files without noticeable quality loss.",
    p2: "It also supports advanced features like transparency, HDR, and a wide color gamut, which JPEG lacks. This allows more detailed and flexible image use in web or media environment",
    p3: "AVIF is excellent for responsive and modern websites where performance matters. Images load faster and consume less bandwidth.",
    p4: "As browser and device support for AVIF grows, converting from JPEG can dramatically reduce page weight and enhance the end-user experience.",

    // SEO Properties
    seo_title: "Convert JPEG to AVIF Online Free - Advanced Image Converter",
    meta_description:
      "Convert JPEG to AVIF online for free. Get smaller, high-quality images with HDR support. Perfect for modern web and apps.",
    canonical_url: "https://skyraconverter.com/jpeg-to-avif",
    og_title: "Free JPEG to AVIF Converter - Optimize for Future Web",
    og_description:
      "Transform JPEG images to AVIF for superior compression and quality. Ideal for web, apps, and HDR visuals. Free and secure.",
    twitter_title: "JPEG to AVIF Converter - Free Online Tool",
    twitter_description:
      "Convert JPEG to AVIF online. Optimize images for web with HDR and transparency. Fast, free, and secure.",
    keywords:
      "jpeg to avif converter, convert jpeg to avif online, next-gen image converter, reduce image size, free jpeg avif converter, avif for web",
    schema_type: "SoftwareApplication",
    featured_snippet_content:
      "JPEG to AVIF conversion offers smaller file sizes with HDR and transparency support, perfect for modern web and apps.",
    faq_question: "How do I convert JPEG to AVIF online?",
    faq_answer:
      "Upload your JPEG, select AVIF as the output, and download the optimized file. It's free, fast, and supports advanced features.",
  },
  {
    id: 24,
    title: "jpeg-to-heic",
    convertion_type: "heic",
    input_format: "jpeg",
    type: "JPEG ➝ HEIC",
    p1: "Converting JPEG to HEIC means upgrading to a smarter, space-saving format that offers improved compression. HEIC files are capable of maintaining better image quality at smaller file sizes than traditional JPEGs, thanks to their use of modern coding standards like HEVC.",
    p2: "JPEG is a widely used format, but it uses older compression methods that often lead to visible artifacts, especially after multiple saves. HEIC counters this with better image preservation, making it more suitable for today's high-resolution images.",
    p3: "While HEIC isn't yet supported by all browsers and image editors, it’s natively used in Apple’s ecosystem and is becoming more common in professional workflows. It’s particularly useful for mobile users who need to save space without losing clarity.",
    p4: "This conversion is a great option if you’re working with limited storage or want to prepare your images for use on modern devices. It allows you to retain better image quality in a smaller file footprint.",

    // SEO Properties
    seo_title: "Convert JPEG to HEIC Online Free - Efficient Image Converter",
    meta_description:
      "Convert JPEG to HEIC online for free. Save space with high-quality images. Perfect for iOS, macOS, and mobile optimization.",
    canonical_url: "https://skyraconverter.com/jpeg-to-heic",
    og_title: "Free JPEG to HEIC Converter - Optimize for Mobile",
    og_description:
      "Transform JPEG images to HEIC for smaller sizes and great quality. Ideal for iOS, macOS, and mobile use. Free and secure.",
    twitter_title: "JPEG to HEIC Converter - Free Online Tool",
    twitter_description:
      "Convert JPEG to HEIC online. Optimize images for mobile and storage. Fast, free, and high-quality conversion.",
    keywords:
      "jpeg to heic converter, convert jpeg to heic online, efficient image converter, mobile image optimization, free jpeg heic converter, heic for ios",
    schema_type: "SoftwareApplication",
    featured_snippet_content:
      "JPEG to HEIC conversion reduces file size with advanced compression, ideal for mobile storage and iOS/macOS compatibility.",
    faq_question: "How do I convert JPEG to HEIC online?",
    faq_answer:
      "Upload your JPEG image, select HEIC as the output format, and download the compressed file. It's free and fast.",
  },
];

function Pngtosvg() {
  const { slug } = useParams();
  const lastWord = slug?.split("-").pop();

  const { state } = useLocation();
  console.log("state", state);

  const topRef = useRef(null);

  // Scroll to top when the route changes
  useEffect(() => {
    topRef.current.scrollIntoView({ behavior: "smooth" });
  }, [slug]); // Trigger when slug changes

  const conversion =
    state?.conversion ||
    conversions.find((item) => item.title === slug || item.id === Number(slug));

  if (!conversion) {
    return (
      <div className="mx-2 lg:mx-32">
        <h4 className="mt-5 ml-5">Conversion Not Found</h4>
        <p className="text-justify px-8 mt-3">
          The requested conversion type does not exist.
        </p>
      </div>
    );
  }

  // Enhanced JSON-LD Schema
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": conversion.schema_type || "SoftwareApplication",
    name: conversion.seo_title,
    description: conversion.meta_description,
    url: conversion.canonical_url,
    applicationCategory: "MultimediaApplication",
    operatingSystem: "Web Browser",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
    },
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.8",
      ratingCount: "1250",
    },
    creator: {
      "@type": "Organization",
      name: "Skyra Converter",
      url: "https://skyraconverter.com",
    },
  };

  // FAQ Schema
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: conversion.faq_question,
        acceptedAnswer: {
          "@type": "Answer",
          text: conversion.faq_answer,
        },
      },
      {
        "@type": "Question",
        name: "Is this converter free to use?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, our image converter is completely free to use with no registration required. We also automatically delete uploaded files after 30 minutes for privacy.",
        },
      },
    ],
  };

  return (
    <>
      {/* <Helmet>
        <title>{`Free ${conversion.type} Converter Online | Skyra Converter`}</title>
        <meta
          name="description"
          content={`${conversion.p1.slice(
            0,
            150
          )}... Convert ${conversion.input_format.toUpperCase()} to ${conversion.convertion_type.toUpperCase()} instantly with our free online converter.`}
        />
        <meta
          name="keywords"
          content={`convert ${conversion.input_format} to ${conversion.convertion_type}, ${conversion.title} tool, online image converter, ${conversion.convertion_type} converter, image file format converter`}
        />
        <meta
          property="og:title"
          content={`Free ${conversion.type} Converter | Skyra Converter`}
        />
        <meta
          property="og:description"
          content={`${conversion.p1.slice(0, 150)}...`}
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content={`https://yourdomain.com/${conversion.title}`}
        />
        <meta
          property="og:image"
          content="https://yourdomain.com/seo-preview.jpg"
        />
        <link
          rel="canonical"
          href={`https://yourdomain.com/${conversion.title}`}
        />
      </Helmet> */}
      <Helmet>
        {/* Primary Meta Tags */}
        <title>{conversion.seo_title}</title>
        <meta name="title" content={conversion.seo_title} />
        <meta name="description" content={conversion.meta_description} />
        <meta name="keywords" content={conversion.keywords} />
        <meta
          name="robots"
          content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
        />
        <meta name="language" content="English" />
        <meta name="author" content="Skyra Converter" />

        {/* Canonical URL */}
        <link rel="canonical" href={conversion.canonical_url} />

        {/* Open Graph Tags */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={conversion.canonical_url} />
        <meta property="og:title" content={conversion.og_title} />
        <meta property="og:description" content={conversion.og_description} />
        <meta
          property="og:image"
          content="https://skyraconverter.com/images/og-image.jpg"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="Skyra Converter" />
        <meta property="og:locale" content="en_US" />

        {/* Twitter Card Tags */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content={conversion.canonical_url} />
        <meta property="twitter:title" content={conversion.twitter_title} />
        <meta
          property="twitter:description"
          content={conversion.twitter_description}
        />
        <meta
          property="twitter:image"
          content="https://skyraconverter.com/images/twitter-card.jpg"
        />
        <meta property="twitter:site" content="@skyraconverter" />
        <meta property="twitter:creator" content="@skyraconverter" />

        {/* Additional SEO Tags */}
        <meta name="theme-color" content="#10b981" />
        <meta name="msapplication-TileColor" content="#10b981" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content="default" />
        <meta name="format-detection" content="telephone=no" />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

        {/* Preload Critical Resources */}
        <link rel="preload" href={logo} as="image" />
        <link rel="preload" href={upload} as="image" />
        <link rel="preload" href={processing} as="image" />
        <link rel="preload" href={download} as="image" />

        {/* DNS Prefetch for External Resources */}
        <link rel="dns-prefetch" href="//fonts.googleapis.com" />
        <link rel="dns-prefetch" href="//www.google-analytics.com" />

        {/* Hreflang for International SEO (if applicable) */}
        <link rel="alternate" hrefLang="en" href={conversion.canonical_url} />

        {/* Article Tags (if applicable) */}
        <meta
          property="article:published_time"
          content="2024-01-01T00:00:00Z"
        />
        <meta property="article:modified_time" content="2024-06-01T00:00:00Z" />
        <meta property="article:author" content="Skyra Converter Team" />
        <meta property="article:section" content="Image Conversion Tools" />
        <meta property="article:tag" content={conversion.input_format} />
        <meta property="article:tag" content={conversion.convertion_type} />
      </Helmet>

      <div ref={topRef}>
        <div className=" mt-8  " style={{}}>
          <Link to="/">
            <div className=" flex  flex-col items-center ">
              <img
                src={logo}
                alt="skyraa converter"
                className="w-[200px] h-[10%]"
                style={{ cursor: "pointer" }}
              />
            </div>
          </Link>
          <Link to="/">
            <h1
              className="gradient-text text-[27px] md:text-[2.2rem] text-center mb-2"
              style={{ cursor: "pointer" }}
            >
              Skyra Convertor
            </h1>
          </Link>
          <p className="px-6 md:px-24  lg:px-32 xl:px-64 text-center">
            We value your privacy. All images you upload are automatically
            deleted from our servers after 30 minutes, ensuring your data stays
            secure while you enjoy a fast, smooth, and hassle-free conversion
            experience
          </p>
        </div>
        {/* Horizontal Line with Three Colors */}
        <div className="  my-5">
          <div className="flex">
            <div className="flex-1 h-2 bg-red-500"></div>
            <div className="flex-1 h-2 bg-yellow-500"></div>
            <div className="flex-1 h-2 bg-green-500"></div>
          </div>

          <div className="px-2 md:px-24  lg:px-32   xl:px-48">
            {/* need to pass the input format and convertion type  to this component  */}
            <UploadD io_type={conversion.input_format} c_type={lastWord} />
          </div>

          <div className="px-2 md:px-24  lg:px-32   xl:px-48">
            <h4 className="mt-5 ml-5">{conversion.type}</h4>
            <p className="text-justify px-8 mt-3 faq-content text-gray-600">
              {conversion.p1}
            </p>
            <p className="text-justify px-8 mt-3 faq-content text-gray-600">
              {conversion.p2}
            </p>
            <p className="text-justify px-8 mt-3 faq-content text-gray-600">
              {conversion.p3}
            </p>
            <p className="text-justify px-8 mt-3 faq-content text-gray-600">
              {conversion.p4}
            </p>
          </div>
        </div>

        <div className="text-center my-8">
          <h3>How to Convert Images to any Format ?</h3>
        </div>
        <div className=" mx-2 md:mx-16 lg:mx-32  xl:mx-48 px-4 sm:flex sm:gap-12 sm:justify-center sm:items-center my-10">
          <div className=" justify-items-center my-10 md:my-0">
            <div className="" style={{ width: "130px", height: "130px" }}>
              <img
                src={upload}
                alt="upload images"
                style={{ width: "100%", height: "100%" }}
              />
            </div>
            <h4 className="mt-3 text-center">1.Choose Images</h4>
            <p className="text-center faq-content text-gray-600">
              Easily upload your images or Upload them directly into your
              browser. No fuss — just a smooth start to your conversion.
            </p>
          </div>
          <div className="justify-items-center my-10 md:my-0 ">
            <div className="" style={{ width: "130px", height: "130px" }}>
              <img
                src={processing}
                alt="upload images"
                style={{ width: "100%", height: "100%" }}
              />
            </div>
            <h4 className="mt-3 text-center ">2.Start Conversion</h4>
            <p className="text-center faq-content text-gray-600">
              Choose your desired output format and optionally compress your
              image for faster sharing and optimized storage. Quick, easy, and
              high-quality every time.
            </p>
          </div>
          <div className="justify-items-center my-10 md:my-0">
            <div className="" style={{ width: "130px", height: "130px" }}>
              <img
                src={download}
                alt="upload images"
                style={{ width: "100%", height: "100%" }}
              />
            </div>
            <h4 className="mt-3 text-center">3.Download Images</h4>
            <p className="text-center faq-content text-gray-600">
              Once the conversion (and optional compression) is complete, simply
              download your high-quality images instantly — quick, clean, and
              hassle-free.
            </p>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}

export default Pngtosvg;
